import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ar from 'vuetify/lib/locale/ar.js';
import en from 'vuetify/lib/locale/en.js';

Vue.use(Vuetify)

export default new Vuetify({
	rtl: true,
	theme: {
		themes: {
			light: {
				primary: '#163963', // #0f4d96
				// error: '#b71c1c',
				orange: '#fb5d33',
				white: '#fbfbfb',
				green: '#2cac3e',
				'light-blue': '#5da2ff',
			},
		},
	},
	
	lang: {
		locales: { en, ar },
		current: 'ar',
	},
})
